import React from 'react';
import { Alert } from 'antd';

const AgeAgreementWarning = () => (
	<Alert
		type="warning"
		message="Attention"
		description={<span>Participants under the age of 18 are not able to submit these forms electronically. If you are under 18, you and your parents or legal guardian must print, sign, scan and email these forms to <a href="mailto:programadministration@isevoyages.org">programadministration@isevoyages.org</a>.</span>}
		showIcon />
);

export default AgeAgreementWarning;


// WEBPACK FOOTER //
// ./portal-components/AgeAgreementWarning/index.jsx